<template>
  <div class="header" :style="computedBackgroundColor">
    <div class="tops">
      <div class="header-width">
        <div class="pull-left">
          服务热线：400-801-0928
          <span style="margin-left: 20px">服务时间：{{ getService() }}</span>
        </div>
        <div class="pull-right">
          <a-spin :spinning="logoutSpinning">
            <div class="rightinfo">
              <!-- <router-link to="/info"><i class="iconfont icon-youxiang margin-right-10"></i><span class="emailnum margin-right-10">(&nbsp;&nbsp;)</span></router-link> -->
              <button class="exit" @click="exit">
                <i class="iconfont icon-tuichu margin-right-10"></i>
                退出登录
              </button>
            </div>
          </a-spin>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>

    <div class="clearfix"></div>

    <div class="logo">
      <div style="padding: 21px 0" :style="computedBackgroundStyle">
        <div class="row">
          <div class="col-md-8 md8 login-top">
            <a :href="userInfo.eduHomeUrl || `#`" target="_blank" v-if="userInfo">
              <img :src="userInfo.eduLogo ? userInfo.eduLogo : `../../../static/images/logo.png`" />
            </a>
            <div class="login-top-str">{{ userInfo.headTitle }}</div>
          </div>
          <div class="col-md-4 md4">
            <div class="download">
              <div class="row" style="height: 105px">
                <!-- <div class="col-md-4" style="position: relative; top: 36px">
                  客户端下载
                </div>
                <div class="col-md-4">
                  <img src="../../assets/images/anzhuo.gif" width="80" height="80" />
                  <div class="texts">Android</div>
                </div>
                <div class="col-md-4">
                  <img src="../../assets/images/Ios.gif" width="80" height="80" />
                  <div class="texts">IOS</div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="topul">
      <div class="header-width">
        <ul>
          <!--<li class="linkli " v-for="(item,index) in linklis" :class="{active:index===ins}" @click="active(index)" :key="index"><router-link :to="item.url">{{item.name}}</router-link></li>-->
          <li class="linkli">
            <router-link to="/" active-class="active" exact>首页</router-link>
          </li>
          <li class="linkli" v-if="$store.state.homeObj.info_column_show != '0'">
            <router-link to="/news" active-class="active">资讯</router-link>
          </li>
          <li class="linkli" v-if="$store.state.homeObj.plan_column_show != '0'">
            <router-link to="/teachplan" active-class="active">教学计划</router-link>
          </li>
          <!-- <li class="linkli">
            <router-link to="/myclass" active-class="active">实践课</router-link>
          </li> -->
          <!-- <li class="linkli">
            <router-link to="/examination" active-class="active">在线考试</router-link>
          </li> -->
          <li class="linkli" v-if="$store.state.homeObj.thesis_column_show != '0'">
            <!--            <router-link to="/graduationmanagement" active-class="active" ></router-link>-->
            <span style="color: #ffffff" @click="openThesis">论文管理</span>
          </li>
          <!-- <li class="linkli">
            <router-link to="https://www.jxjypt.cn/indexpage/" active-class="active">论坛</router-link>
          </li> -->
          <li class="linkli" v-if="$store.state.homeObj.live_column_show != '0'">
            <router-link to="/distancelearning" active-class="active">远程授课</router-link>
          </li>
<!--           <li class="linkli" v-if="$store.state.homeObj.thesis_defense_column_show != '0'">-->
<!--            <router-link to="/defenseOnline" active-class="active">毕业论文答辩</router-link>-->
<!--          </li>-->
          <li
            class="linkli"
            v-if="$store.state.homeObj.thesis_defense_column_show != '0'"
          >
            <router-link to="/defenseOnline" active-class="active"
              >在线答辩</router-link
            >
          </li>
          <li
            class="linkli"
            v-if="$store.state.homeObj.material_order_show != '0'"
            v-cloak
          >
            <router-link to="/textbookorder" active-class="active"
              >教材订购</router-link
            >
          </li>
          <li class="linkli" v-if="$store.state.homeObj.doc_center_column_show != '0'" v-cloak>
            <router-link to="/documentcenter" active-class="active">文档中心</router-link>
          </li>
          <li class="linkli" v-if="$store.state.homeObj.offline_teach_list_show != '0'">
            <router-link to="/offlineteach" active-class="active">线下授课</router-link>
          </li>
          <li class="linkli" v-if="$store.state.homeObj.credit_bank_show == '1'" v-cloak>
            <router-link to="/creditBank" active-class="active">学分银行</router-link>
          </li>
          <li class="linkli" v-if="$store.state.homeObj.tuition_fee == '1'" v-cloak>
            <router-link to="/tuitionPayment" active-class="active">我的缴费</router-link>
          </li>
          <li class="linkli" v-if="$store.state.homeObj.tduck_form_show == '1'" v-cloak>
            <router-link to="/tduckForm" active-class="active">问卷调查</router-link>
          </li>
          <li class="linkli" v-if="userInfo.eduCode == '513' && userInfo.grade == 2025">
            <span style="color: #ffffff" @click="goNotification">录取通知书</span>
          </li>
          <li class="linkli" v-if="$store.state.homeObj.show_graduation_conditions == '1'" v-cloak>
            <router-link to="/graduatonCondition" active-class="active">
              {{ $store.state.homeObj.show_degree_conditions == '1' ? '毕业/学位' : '毕业' }}
            </router-link>
          </li>
          <li class="linkli" v-if="$store.state.homeObj.course_mode == '3'">
            <router-link to="/courseselection" active-class="active">在线选课</router-link>
          </li>
          <li class="linkli" v-if="$store.state.homeObj.fee_qry == '1'" v-cloak>
            <a :href="$store.state.homeObj.fee_qry_url" target="_blank" style="color: #fff">学费查询</a>
          </li>

          <!-- 更具什么参数来展示待定 -->
          <li class="linkli" v-if="$store.state.homeObj.showDegreeFlag == '1'" v-cloak>
            <router-link to="/degreemodule" active-class="active">学位考核</router-link>
          </li>
        </ul>
      </div>
    </div>
    <a-modal title="修改密码" :visible="ForgetPasswordVisible" :closable="false" width="50%" :bodyStyle="modalStyle" :footer="null">
      <forget-password ref="forgetPassword" />
    </a-modal>

    <a-modal title="实名认证" :width="500" :visible="bindTelVisiable" :closable="false" :maskClosable="false" :cancelText="'已认证'">
      <p style="font-size: 15px; font-weight: 700; text-align: center">
        {{ bindMessage ? bindMessage : '扫码关注“联大学堂”公众号进行认证,认证后请点击下方按钮进入！' }}
      </p>

      <div style="width: 130px; height: 130px; margin: 0px auto; box-sizing: border-box">
        <!-- <img :src="QRCodeUrl" alt="" style="width: 130px; height: 130px" /> -->
        <!-- <div class="code" @click="handleCertified">
          <canvas ref="qrCanvas"></canvas>
        </div> -->
        <div class="code">
          <img src="../../assets/images/qrcode.jpg" style="width: 130px; height: 130px" />
        </div>
      </div>
      <template slot="footer">
        <a-button @click="exit">退出登录</a-button>
        <a-button type="primary" @click="handleCertified">已认证</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ForgetPassword from '@/pages/PersonalCenters/components/ForgetPassword';
import QRCode from 'qrcode';
import axios from 'axios';

export default {
  name: 'HomeHeader',
  components: { ForgetPassword },
  data: function () {
    return {
      linklis: [
        {
          name: '首页',
          url: '/',
        },
        {
          name: '专业',
          url: '/major',
        },
        {
          name: '简介',
          url: '/detail/0001',
        },
        {
          name: '资讯',
          url: '/major',
        },
        {
          name: '预报名',
          url: '/',
        },
        {
          name: '考前辅导',
          url: '/',
        },
      ],
      ins: 0,
      url: ``,
      websock: null,
      heartCheck: null,
      logoutSpinning: false,
      ForgetPasswordVisible: false,
      modalStyle: {
        height: '400px',
        overflowY: 'auto',
      },
      bindTelVisiable: false,
      bindMessage: '',
      QRCodeUrl: '',
      randomCode: null,
      isScanning: false, // 新增标志
      // cancelTokenSource: null,
      uuid: '',
      flag: false,
      headerBgUrl: '',
      headerBgColor: '',
    };
  },
  computed: {
    ...mapState(['userInfo']),

    // 计算属性生成背景样式
    computedBackgroundStyle() {
      if (localStorage.getItem('themeServer')) {
        this.headerBgUrl = '';
        // console.log(JSON.parse(localStorage.getItem("themeServer")), 'JSON.parse(localStorage.getItem("themeServer"))');
        const headerArr = JSON.parse(localStorage.getItem('themeServer')).filter((item) => item.themeCode === 'header_bg');
        if (headerArr.length > 0) {
          if (headerArr[0].image) {
            this.headerBgUrl = JSON.parse(headerArr[0].image)[0].filePath;
          }
        }
      } else {
        axios
          .get(
            `/sys/sysClientStyleConfig/list?clientType=pc&eduCode=${
              localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).eduCode : ''
            }`
          )
          .then((res) => {
            this.headerBgUrl = '';
            // console.log(JSON.parse(localStorage.getItem("themeServer")), 'JSON.parse(localStorage.getItem("themeServer"))');
            const headerArr = res.result.filter((item) => item.themeCode === 'header_bg');
            console.log(headerArr, 'headerArr');
            if (headerArr.length > 0) {
              if (headerArr[0].image) {
                console.log(JSON.parse(headerArr[0].image)[0].filePath, 'headerArr[0].image');
                this.headerBgUrl = JSON.parse(headerArr[0].image)[0].filePath;
              }
            }
            console.log('再次获取头部背景图');
          });
      }
      console.log(this.headerBgUrl, 'this.headerBgUrl');

      // 有URL时使用图片
      if (this.headerBgUrl) {
        return {
          backgroundImage: `url("${this.headerBgUrl}")`, // 双引号避免URL含特殊字符问题
          backgroundPosition: 'right bottom',
          backgroundRepeat: 'no-repeat',
        };
      }
    },

    computedBackgroundColor() {
      this.headerBgColor = '';

      if (localStorage.getItem('themeServer')) {
        // console.log(JSON.parse(localStorage.getItem("themeServer")), "localStorage.getItem('themeServer'))");
        const headerArr = JSON.parse(localStorage.getItem('themeServer')).filter((item) => item.themeCode === 'header_bg');
        if (headerArr.length > 0) {
          if (headerArr[0].css) {
            this.headerBgColor = headerArr[0].css;
          }
        }
      } else {
        axios
          .get(
            `/sys/sysClientStyleConfig/list?clientType=pc&eduCode=${
              localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).eduCode : ''
            }`
          )
          .then((res) => {
            const headerArr = res.result.filter((item) => item.themeCode === 'header_bg');
            if (headerArr.length > 0) {
              if (headerArr[0].css) {
                this.headerBgColor = headerArr[0].css;
              }
            }
            console.log('再次获取头部背景颜色');
          });
      }

      console.log(this.headerBgColor, '获取头部背景颜色 headerBgColor');
      if (this.headerBgColor) {
        return JSON.parse(this.headerBgColor);
      }
      // // 无URL时使用颜色
      return {
        backgroundColor: 'var(--bgColor1)', // 使用CSS变量关联Sass变量
      };
    },
  },
  created() {
    this.handleCertified();
  },
  mounted() {
    this.isweakPassword();
  },
  methods: {
    getService() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // 月份从0开始，所以+1
      const currentDay = currentDate.getDate();

      // 判断是否是夏令时（5月1日-10月1日）
      const isSummerTime = (currentMonth > 5 && currentMonth < 10) || (currentMonth === 5 && currentDay >= 1) || (currentMonth === 10 && currentDay <= 1);

      // 使用三目运算符设置服务时间
      const serviceHours = isSummerTime ? '9:00 - 18:00' : '9:00 - 17:30';
      console.log(`当前服务时间: ${serviceHours}`);
      return serviceHours;
    },
    /**
     * 获取二维码并生成登录凭证
     *
     * 流程说明:
     * 1. 从接口获取二维码链接
     * 2. 解析链接参数保存randomCode
     * 3. 初始化canvas并生成二维码
     * 4. 触发扫码登录监听
     *
     * @returns {void} 无返回值
     */
    // getQrCode() {
    //   this.axios.get("/sys/login/getQrCode").then((res) => {

    //   });
    // },
    scanCodeLogin() {
      if (this.flag) return;
      if (this.isScanning) return; // 已有请求在进行
      this.isScanning = true;
      // // 创建取消令牌
      // if (this.cancelTokenSource) {
      //   this.cancelTokenSource.cancel("组件重复创建，取消上一次请求");
      // }
      // this.cancelTokenSource = this.axios.CancelToken.source();
      // if(!flag){
      this.axios
        .get('/sys/bind/scanCodeBind?randomCode=' + this.randomCode)
        .then((res) => {
          if (res.success) {
            // 继续轮询
            if (!this.flag) {
              this.isScanning = false;
              this.scanCodeLogin();
            }
          } else {
            //继续拿二维码
            this.isScanning = false;
            this.handleCertified();
          }
        })
        .catch((error) => {
          console.error('扫码失败:', error);
          if (this.axios.isCancel && this.axios.isCancel(error)) {
            console.log('请求已取消：', error.message);
          } else {
            console.error('扫码失败:', error);
          }
          this.isScanning = false; // 重置标志
        });
      // }
    },

    handleCertified() {
      this.axios.get('/sys/after/loginValid').then((item) => {
        if (item.result) {
          // this.creatModal() //这是调用的绑定手机号弹窗
          this.bindTelVisiable = true;
          this.bindMessage = item.message;

          // console.log(item.result, "item.result");
          // 先获取 redirect_uri 的参数部分
          const url = item.result;
          const urlObj = new URL(url);
          const stateValue = urlObj.searchParams.get('state');
          this.randomCode = stateValue; // 保存 randomCode
          // 获取 canvas 元素的引用
          this.$nextTick(() => {
            const canvas = this.$refs.qrCanvas;
            if (!canvas) return;
            // console.log(canvas, "canvas");
            // 设定 canvas 的宽高（可根据需求调整）
            canvas.width = 130;
            canvas.height = 130;
            // 调用 QRCode 函数生成二维码，并渲染到 canvas 上
            QRCode.toCanvas(canvas, url, { width: 130 }, (error) => {
              if (error) console.error(error, 'QRCode.toCanvas error');
              console.log('QRCode generated!');
            });
            console.log('继续轮询');
            this.scanCodeLogin();
          });
        } else {
          //若通过则调取信息
          this.isScanning = true;
          this.scanCodeLogin();
          console.log('通过');
          this.flag = true;
          // if (this.cancelTokenSource) {
          //   this.cancelTokenSource.cancel("组件销毁，取消请求");
          // }
          this.bindTelVisiable = false;
        }
      });
    },
    // 弱密码强制弹窗修改
    isweakPassword() {
      let weakPassword = JSON.parse(localStorage.getItem('WEAK_PASSWORD'));
      if (weakPassword) {
        this.$message.warning('您的密码过于简单，为了您的账号安全，请重新修改密码!');
        this.ForgetPasswordVisible = true;
      }
    },
    active(num) {
      this.ins = num;
    },
    changeActive($event) {},
    removeActive($event) {},
    exit() {
      this.logoutSpinning = true;
      this.axios.get(`sys/logout`).then((res) => {
        if (localStorage.getItem('isLoginByInter') === '2' && localStorage.getItem('redirectUrl')) {
          location.href = localStorage.getItem('redirectUrl');
          localStorage.clear();
          return;
        }
        if (res.success) {
          this.$message.success(res.result, 1);
        }
        setTimeout(() => {
          this.common.toURL(`/login?id=${this.userInfo.eduCode}`);
          // this.$router.replace('/login')
          this.logoutSpinning = false;
        }, 1000);
      });
    },
    openThesis() {
      let userinfo = JSON.parse(localStorage.getItem('userInfo'));
      const thesisApi = process.env.thesisApi;
      this.axios.get(`${thesisApi}/eduThesisStuLogin/eduThesisStuLogin/getQuickToken?studentId=` + userinfo.id).then((res) => {
        console.log(res);
        window.open(process.env.thesisUrl + '/quickLogin?uuid=' + res.result);
      });
    },
    goNotification() {
      const url = `https://ld-a.oss-cn-beijing.aliyuncs.com/cj21/513/2025级/录取通知书/${this.userInfo.name}_${this.userInfo.idNo}.pdf`;
      window.open(url);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';

[v-cloak] {
  display: none;
}

.header {
  height: 229px;
  position: relative;

  .righinfo {
    color: #fff;
  }

  .exit {
    background: $bgColor;
    padding: 2px 12px;
    color: #fff;
    font-size: 14px;
    border-radius: 23px;
  }

  .topul {
    height: 50px;
    line-height: 50px;
    background: $navigationBgColor;
    width: $pageWidth;
    margin: 0 auto;
  }

  .header-width {
    width: $pageWidth;
    margin: 0 auto;
  }

  .login-top {
    display: flex;
    align-items: center;

    .login-top-str {
      margin-left: 20px;
      color: #FFFFFF;
      font-size: 30px;
    }
  }
}

.header-left {
  float: left;
  margin-top: 10px;
}

.header-right {
  padding: 0 0.1rem;
  margin-top: 8px;
  float: right;
  text-align: center;
  color: #fff;

  p {
    line-height: 30px;
  }
}

.linkli {
  float: left;
  padding: 0 20px;
  cursor: pointer;

  a {
    color: #fff;
  }

  a:hover {
    color: #fff;
  }
}

.active {
  border-bottom: 2px solid #fff;
  padding-bottom: 10px;
}

.tops {
  height: 36px;
  line-height: 36px;
  background: $headerTile;
  color: #fff;
}

.rightinfo {
  color: #fff;

  a {
    color: #fff;
  }
}

.download {
  color: #fff;

  .col-md-4 {
    text-align: center;
    margin-right: 0;
    margin-left: 0;

    .texts {
      margin-top: 10px;
    }
  }
}

.logo {
  height: 143px;
  width: $pageWidth;
  margin: 0 auto;

  .md8 {
    -webkit-box-flex: 0;
    flex: 0 0 75%;
    max-width: 75%;
  }

  .md4 {
    -webkit-box-flex: 0;
    flex: 0 0 25%;
    max-width: 25%;
  }
}

.code {
  width: 130px;
  height: 130px;

  canvas {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/Header.vue